import _ from 'lodash';

function setOptionsStyle(element, style) {
    element.classList.remove('style-1');
    element.classList.remove('style-2');
    element.classList.remove('style-3');
    element.classList.remove('style-1-columns');
    element.classList.remove('style-2-columns');
    element.classList.remove('style-3-columns');
    element.classList.remove('style-4-columns');
    element.classList.remove('style-5-columns');
    element.classList.remove('style-6-columns');
    element.classList.add(style);
}

function setQuestionType(element, type) {
    element.classList.remove('persian');
    element.classList.remove('english-ltr');
    element.classList.remove('english-rtl');
    element.classList.add(type);
}

window.tinymce.PluginManager.add('styles', function init(editor) {
    const persianAnswerTemplate = `<div class='answer' style='overflow: hidden; line-height: 200%; margin-bottom: 0; margin-top: 0px;'>
    <div class='title'><strong>گزینه «»</strong></div>
    <div class='description'></div>
</div>`;

    const persianVerseTemplate = `<div class='poem'>
    <div class='verse'></div>
    <div class='verse'></div>
</div>`;

    const menu = [];

    menu.push.apply(menu, _.map(Array(3), (__, index) => ({
        text: window.pgettext('examination:question', `type-${index + 1}`),
        onclick: () => {
            const optionsTemplate = `<div class='options-container styled'>
    ${_.map(Array(editor.options), () => '<div class=\'option\'></div>').join('')}
</div>`;
            const temporaryElement = document.createElement('div');
            temporaryElement.innerHTML = optionsTemplate;
            setOptionsStyle(temporaryElement.firstChild, 'style-1-columns');
            const questionTemplate = `<div class='question'>
    <div class='description'></div>
    ${temporaryElement.innerHTML}
</div>`;

            const type = {
                0: 'persian',
                1: 'english-ltr',
                2: 'english-rtl',
            }[index];
            editor.focus();
            const rng = editor.selection.getRng(true);
            const currentElement = rng.startContainer.nodeName === '#text' ? rng.startContainer.parentElement : rng.startContainer;
            const questionElement = currentElement.closest('.question');
            if (questionElement) {
                setQuestionType(questionElement, type);
            }
            else {
                const temporaryElement = document.createElement('div');
                temporaryElement.innerHTML = questionTemplate + '<br/>';
                setQuestionType(temporaryElement.firstChild, type);
                editor.selection.setContent(temporaryElement.innerHTML);
            }
            editor.nodeChanged();
        },
    })));
    menu.push({text: '|'});

    menu.push.apply(menu, _.map(Array(6), (__, index) => ({
        text: window.pgettext('examination:question', `style-${index + 1}`),
        onclick: () => {
            const mode =  `style-${index + 1}-columns`;
            editor.focus();
            const rng = editor.selection.getRng(true);
            const currentElement = rng.startContainer.nodeName === '#text' ? rng.startContainer.parentElement : rng.startContainer;
            const containerElement = currentElement.closest('.options-container');
            if (containerElement) {
                setOptionsStyle(containerElement, mode);
            }
            else {
                const temporaryElement = document.createElement('div');
                const optionsTemplate = `<div class='options-container styled'>
    ${_.map(Array(editor.options), () => '<div class=\'option\'></div>').join('')}
</div>`;
                temporaryElement.innerHTML = optionsTemplate + '<br/>';
                setQuestionType(temporaryElement.firstChild, mode);
                editor.selection.setContent(temporaryElement.innerHTML);
            }
            editor.nodeChanged();
        },
    })));
    menu.push({text: '|'});

    const styles = [
        {
            title: window.gettext('Answer'),
            content: persianAnswerTemplate,
        },
        {
            title: window.gettext('Verse'),
            content: persianVerseTemplate,
        },
    ];
    menu.push.apply(menu, _.map(styles, style => ({
        text: style.title,
        onclick: () => {
            editor.focus();
            editor.selection.setContent(style.content + '<br/>');
            editor.nodeChanged();
        },
    })));

    editor.addButton('question_styles', {
        type: 'menubutton',
        tooltip: window.gettext('Styles'),
        icon: 'custom fa-insert-template',
        menu,
    });

    editor.addButton('guide', () => {
        function showDialog() {
            editor.windowManager.open({
                title: window.gettext('Guide'),
                width: 734,
                height: 600,
                file: window.hashed_paths['tinymce_guide.html'],
                buttons: [],
            });
        }

        return {
            tooltip: window.gettext('Guide'),
            icon: 'custom fa-question',
            onclick: showDialog,
        };
    });
});

window.pgettext('examination:question', 'type-1');
window.pgettext('examination:question', 'type-2');
window.pgettext('examination:question', 'type-3');

window.pgettext('examination:question', 'style-1');
window.pgettext('examination:question', 'style-2');
window.pgettext('examination:question', 'style-3');
window.pgettext('examination:question', 'style-4');
window.pgettext('examination:question', 'style-5');
window.pgettext('examination:question', 'style-6');
